import React, { useState, useEffect } from 'react';
import useStyles from './styles';

interface DiceProps {
  isRolling: boolean;
  diceFace: number[];
  index: number;
  diceFaceCallback: React.Dispatch<React.SetStateAction<number[]>>;
}

export default function Dice({
  isRolling,
  diceFace,
  index,
  diceFaceCallback,
}: DiceProps) {
  const classes = useStyles();

  const faces = 6;

  const [style, setStyle] = useState<any>({});

  function getRandom(max: number, min: number) {
    return (Math.floor(Math.random() * (max - min)) + min) * 360;
  }

  function rotation() {
    switch (diceFace[index]) {
      case 1:
        setStyle({ transform: 'rotateX(0)' });
        break;
      case 2:
        setStyle({ transform: 'rotateX(-180deg)' });
        break;
      case 3:
        setStyle({ transform: 'rotateY(-90deg)' });
        break;
      case 4:
        setStyle({ transform: 'rotateY(90deg)' });
        break;
      case 5:
        setStyle({ transform: 'rotateX(-90deg)' });
        break;
      case 6:
        setStyle({ transform: 'rotateX(90deg)' });
        break;

      default:
        break;
    }
  }

  function rollDice() {
    const min = 6;
    const max = 10;
    const xRand = getRandom(min, max);
    const yRand = getRandom(min, max);

    setStyle({
      WebkitTransform: 'rotateX(' + xRand + 'deg) rotateY(' + yRand + 'deg)',
      transform: 'rotateX(' + xRand + 'deg) rotateY(' + yRand + 'deg)',
    });
    setTimeout(() => {
      setStyle({
        WebkitTransform:
          'rotateX(' + yRand / 2 + 'deg) rotateY(' + xRand / 2 + 'deg)',
        transform:
          'rotateX(' + yRand / 2 + 'deg) rotateY(' + xRand / 2 + 'deg)',
      });
      setTimeout(() => {
        const newDiceFace = diceFace;
        newDiceFace[index] = Math.floor(Math.random() * faces) + 1;
        diceFaceCallback(newDiceFace);
        rotation();
      }, 500);
    }, 500);
  }

  useEffect(() => {
    if (isRolling) {
      rollDice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRolling]);

  return (
    <div className={classes.container}>
      <div className={`${classes.dice}`} style={style}>
        <div className={classes.face1}>
          <span className={`${classes.dot} ${classes.face1Dot1}`}></span>
        </div>
        <div className={classes.face2}>
          <span className={`${classes.dot} ${classes.face2Dot1}`}></span>
          <span className={`${classes.dot} ${classes.face2Dot2}`}></span>
        </div>
        <div className={classes.face3}>
          <span className={`${classes.dot} ${classes.face3Dot1}`}></span>
          <span className={`${classes.dot} ${classes.face3Dot2}`}></span>
          <span className={`${classes.dot} ${classes.face3Dot3}`}></span>
        </div>
        <div className={classes.face4}>
          <span className={`${classes.dot} ${classes.face4Dot1}`}></span>
          <span className={`${classes.dot} ${classes.face4Dot2}`}></span>
          <span className={`${classes.dot} ${classes.face4Dot3}`}></span>
          <span className={`${classes.dot} ${classes.face4Dot4}`}></span>
        </div>
        <div className={classes.face5}>
          <span className={`${classes.dot} ${classes.face5Dot1}`}></span>
          <span className={`${classes.dot} ${classes.face5Dot2}`}></span>
          <span className={`${classes.dot} ${classes.face5Dot3}`}></span>
          <span className={`${classes.dot} ${classes.face5Dot4}`}></span>
          <span className={`${classes.dot} ${classes.face5Dot5}`}></span>
        </div>
        <div className={classes.face6}>
          <span className={`${classes.dot} ${classes.face6Dot1}`}></span>
          <span className={`${classes.dot} ${classes.face6Dot2}`}></span>
          <span className={`${classes.dot} ${classes.face6Dot3}`}></span>
          <span className={`${classes.dot} ${classes.face6Dot4}`}></span>
          <span className={`${classes.dot} ${classes.face6Dot5}`}></span>
          <span className={`${classes.dot} ${classes.face6Dot6}`}></span>
        </div>
      </div>
    </div>
  );
}
